import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AlertComponent } from './alert/alert.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { TagComponent } from './tag/tag.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { ToggleComponent } from './toggle/toggle.component';
import { TabsComponent } from './tabs/tabs.component';
import { TabComponent } from './tabs/tab.component';
import { DialogComponent } from './dialog/dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { SelectComponent } from './select/select.component';
import { ListboxComponent } from './listbox/listbox.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { SortableHeaderComponent } from './data-table/sortable-header.component';
import { PaginatorComponent } from './data-table/paginator.component';
import { ToastComponent } from './toast/toast.component';

const COMPONENTS = [
  AlertComponent,
  SpinnerComponent,
  TagComponent,
  CheckboxComponent,
  ToggleComponent,
  TabsComponent,
  TabComponent,
  DialogComponent,
  ConfirmDialogComponent,
  SelectComponent,
  ListboxComponent,
  DatepickerComponent,
  FileUploadComponent,
  SortableHeaderComponent,
  PaginatorComponent,
  ToastComponent,
];

@NgModule({
  declarations: COMPONENTS,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: COMPONENTS,
})
export class UiModule {}
